import { render, staticRenderFns } from "./FarmProductionPerformanceForm.vue?vue&type=template&id=ea47f870&scoped=true&"
import script from "./FarmProductionPerformanceForm.vue?vue&type=script&lang=ts&"
export * from "./FarmProductionPerformanceForm.vue?vue&type=script&lang=ts&"
import style0 from "./FarmProductionPerformanceForm.vue?vue&type=style&index=0&id=ea47f870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea47f870",
  null
  
)

export default component.exports